export default "__VITE_ASSET__DL1xa3Mx__"